import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Banner(props) {
  return (
    <div className="service_usa" style={{ backgroundColor: "#281d40" }}>
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="my-auto">
            <div className="banenr_content">
              <h1>
                <span>Telemedicine App</span> Development Company
              </h1>
              <p>
                As the line between healthcare and technology thins, our
                telemedicine app development company is the rising phoenix that
                brings the revolution. We provide tailored telemedicine apps to
                allow healthcare businesses to surpass physical location
                bindings. Join us in revolutionizing the healthcare delivery
                model—let's mold a new future prototype.
              </p>
              <Link
                to="/contact"
                className="border_btn"
                aria-label="TekRevol Contact"
              >
                Let’s Build Your Telemedicine App!
              </Link>
            </div>
          </Col>
          <Col xs={12} md={6} lg={6} xl={6} xxl={6} className="mt-auto">
            <StaticImage
              src="../../images/services-usa/telemedicine/banner_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={776}
              height={667}
            />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default Banner;
